import RoomsContent from './Content'
import * as React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import { useCallback } from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { UseMultiRoomSelectionReturn } from 'businessTraveller/hooks/useMultiRoomSelection'

interface Props {
  onApply: () => void
  // Pass the hook to use for reading state. Must read state from hook directly (not props)
  // because modal is rendered outside the React tree, so props passed via showModal()
  // would be stale and not update when state changes.
  useSelection: () => UseMultiRoomSelectionReturn
}

export default function RoomsModal({ onApply, useSelection }: Props) {
  const modalElementContext = useModalElementContext()

  const {
    occupancies,
    totalTravellers,
    onRoomCountChange,
  } = useSelection()

  const dismiss = useCallback(() => {
    modalElementContext.resolve()
    onApply()
  }, [modalElementContext, onApply])

  return <Modal
    mode="drawer"
    title="How many rooms?"
    primaryActionText="Continue"
    onPrimaryActionClick={dismiss}
  >
    <RoomsContent size="large" rooms={occupancies} onRoomCountChange={onRoomCountChange} travellerCount={totalTravellers} />
  </Modal>
}
